import { configureStore } from '@reduxjs/toolkit';

import langReducer from '@/configuration/lang/langSlice';
import loginReducer from '@/configuration/login/loginSlice';
import tokenReducer from '@/configuration/tokenHandling/tokenSlice';
import appReducer from '@/features/app/appSlice';
import { dfpFrontendApi } from '@/services/dfpFrontendApi';
import { triggerDfpMessageApi } from '@/services/triggerDfpMessageApi';
import configReducer from './configSlice';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        [dfpFrontendApi.reducerPath]: dfpFrontendApi.reducer,
        [triggerDfpMessageApi.reducerPath]: triggerDfpMessageApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(dfpFrontendApi.middleware, triggerDfpMessageApi.middleware),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
